var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDe = function SvgDe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "inherit",
    height: "inherit",
    fill: "none",
    viewBox: "0 0 19 19"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#de_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#de_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M26 0H-6v19.2h32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D00",
    d: "M26 6H-6v7h32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCE00",
    d: "M26 13H-6v6h32z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "de_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "#fff",
    rx: 9.5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "de_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-6 0h32v19.2H-6z"
  })))));
};
export default SvgDe;